import { useEffect, useState } from "react";

import { useInterval } from "usehooks-ts";

import { dateFromNow } from "src/utils/datetime";

/**
 * Returns a relative time string for a given timestamp.
 * Updates the time every 30 seconds.
 */
export const useRelativeTime = (timestamp: string | undefined) => {
  const [timeFromNow, setTimeFromNow] = useState<string | undefined>(
    timestamp ? dateFromNow(timestamp) : undefined,
  );

  useInterval(() => {
    setTimeFromNow(timestamp ? dateFromNow(timestamp) : undefined);
  }, 30 * 1_000);

  useEffect(() => {
    setTimeFromNow(timestamp ? dateFromNow(timestamp) : undefined);
  }, [timestamp]);

  return timeFromNow;
};
